import { Column, COLUMN_SIZES, ColumnTypes } from 'wflow-cdk';
import { PeppolColumnKey } from '../peppol-items.interface';

export const PEPPOL_COLUMN_DEFINITIONS: Record<PeppolColumnKey, Column> = {
  direction: {
    key: 'direction',
    label: 'PEPPOL.COLUMNS.Direction',
    size: COLUMN_SIZES.SYMBOL,
    resizable: true,
    type: ColumnTypes.STATE,
  },
  status: {
    key: 'status',
    label: 'PEPPOL.COLUMNS.Status',
    size: COLUMN_SIZES.SYMBOL,
    resizable: true,
    type: ColumnTypes.STATE,
  },
  document: {
    key: 'document',
    label: 'PEPPOL.COLUMNS.Document',
    size: COLUMN_SIZES.SYMBOL,
    resizable: true,
    type: ColumnTypes.STATE,
  },
  sender: {
    key: 'sender',
    label: 'PEPPOL.COLUMNS.Sender',
    size: COLUMN_SIZES.DESCRIPTION,
    resizable: true,
  },
  receiver: {
    key: 'receiver',
    label: 'PEPPOL.COLUMNS.Receiver',
    size: COLUMN_SIZES.DESCRIPTION,
    resizable: true,
  },
  partner: {
    key: 'partner',
    label: 'PEPPOL.COLUMNS.Partner',
    size: COLUMN_SIZES.DESCRIPTION,
    resizable: true,
  },
  invoiceType: {
    key: 'invoiceType',
    label: 'PEPPOL.COLUMNS.InvoiceType',
    size: COLUMN_SIZES.STRING,
    resizable: true,
  },
  lastAction: {
    key: 'lastAction',
    label: 'PEPPOL.COLUMNS.LastAction',
    size: COLUMN_SIZES.DESCRIPTION,
    resizable: true,
  },
  receivedDate: {
    key: 'receivedDate',
    label: 'PEPPOL.COLUMNS.ReceivedDate',
    size: COLUMN_SIZES.DATE,
    resizable: true,
    sortable: true,
  },
  sentDate: {
    key: 'sentDate',
    label: 'PEPPOL.COLUMNS.SentDate',
    size: COLUMN_SIZES.DATE,
    resizable: true,
    sortable: true,
  },
  date: {
    key: 'date',
    label: 'PEPPOL.COLUMNS.Date',
    size: COLUMN_SIZES.DATE,
    resizable: true,
    sortable: true,
  },
};
